<template>
    <div>
        <div class="box sticky top-pos-0 is-paddingless z-1">
          <div class="media is-mobile padding-5" v-if="!displaySearch">
            <div class="media-content pt-5 tags are-small is-marginless">
              <span v-for="tag in catalogTags" :key="tag.mid" class="tag" :class="[fltrParm.tag === tag.mid? 'is-info': '']">
                  <a :class="[fltrParm.tag === tag.mid? 'has-text-white': 'has-text-info']" v-on:click="filterByTag(tag)">{{tag.name}}</a>
                  <button class="delete is-small" v-on:click="deleteFilterTag" v-if="fltrParm.tag === tag.mid"></button>
              </span>
            </div>
            <a v-on:click="displaySearch = true" class="is-pulled-right margin-5">
              <span class="icon has-text-primary">
                <font-awesome-icon icon="search"/>
              </span>
            </a>
          </div>
          <div class="media padding-5" v-else>
            <div class="control has-icons-left has-icons-right media-content">
              <input class="input is-rounded" type="text" placeholder="Search by name" v-model="searchText" v-on:keyup="filterBySearch">
              <span class="icon is-small is-left">
                <font-awesome-icon icon="search"/>
              </span>
            </div>
            <a class="icon is-small is-pulled-right margin-5" v-on:click="closeSearch">
              <font-awesome-icon icon="times"/>
            </a>
          </div>
        </div>
        <!-- <CarouselSlider v-if="currentDeals">

        </CarouselSlider> -->
        <div class="columns is-mobile overflow-y-hidden " v-if="currentDeals && !resourceId">
            <div v-for="deal in currentDeals" :key="'cat_deal_'+deal.mid" class="column is-two-thirds-mobile is-one-third-tablet is-narrow" @click="displayDealDetail(deal.mid)">
              <article class="level box is-mobile padding-5 h-100">
                <div class="level-left pr-5">
                  <span class="has-text-primary" v-html="deal.dealTag"></span>
                </div>
                <div class="w-70 is-pulled-right has-text-left">
                  <p class="has-text-weight-medium is-size-7 line-clamp text-elipsis">{{ deal.description }}</p>
                </div>
              </article>
            </div>
          </div>
        <template v-if="filteredCatalog">
          <template v-for="category in filteredCatalog">
            <div :key="'catalog_'+category.mid" :id="'catalog_'+category.mid" v-if="!isEmpty(category.items) || !isEmpty(category.subCategories)">
              <div class="title has-text-weight-medium sticky top-3 has-background-white lineheight-small" :id="'cat_'+category.mid"><span class="pl-25">{{category.name}}</span></div>
              <div v-if="category.items" class="columns is-multiline is-mobile is-variable is-1-mobile is-2-tablet is-2-desktop">
                  <item v-for="item in category.items" :item="item" v-bind:key="'catalog_item_'+item.mid" v-on:showitemdialog="displayItemDialog($event)" v-on:showcartitemdialog="displayCartItemDialog($event)" v-on:showcatalogerr="displayCatalogErr"></item>
              </div>
              <div v-for="subCategory in category.subCategories" :key="'catalog_'+subCategory.mid" :id="'catalog_'+subCategory.mid">
                  <h3 class="title is-4 has-text-grey has-text-weight-medium pl-5" :id="'subCat_'+subCategory.mid">{{subCategory.name}}</h3>
                  <div class="columns is-multiline is-mobile is-variable is-1-mobile is-2-tablet is-2-desktop">
                      <item v-for="item in subCategory.items" :item="item" v-bind:key="item.id" v-on:showitemdialog="displayItemDialog($event)" v-on:showcartitemdialog="displayCartItemDialog($event)" v-on:showcatalogerr="displayCatalogErr"></item>
                  </div>
                  <hr class="hr"/>
              </div>
              <hr class="hr"/>
            </div>
          </template>
        </template>
        <div v-else>
          No Items available
        </div>
        <router-view name="outlet">
          <template v-if="showModal">
              <item-dialog></item-dialog>
          </template>
        </router-view>
        <template>
            <div class="padding-5 floating-btn is-hidden-tablet field has-addons is-centered w-100 is-flex z-1" v-if="!displaySearch">
              <div class="control" v-if="filterCats">
                <div class="dropdown is-up" :class="{ 'is-active' : isMenuActive }">
                    <div class="dropdown-trigger">
                        <button class="button is-link is-medium" aria-haspopup="true" aria-controls="menu-filter" v-on:click="swapMenuActive">
                            <span class="icon is-small is-size-6">
                                <font-awesome-icon icon="angle-up"/>
                            </span>
                            <span class="is-size-6">Menu</span>
                        </button>
                    </div>
                    <div class="dropdown-menu" id="menu-filter" role="menu">
                        <div class="dropdown-content">
                            <div class="dropdown-item enable-scroll max-60vh overflow-x-hidden">
                                <div v-for="cat in filterCats" :key="cat.mid">
                                  <a v-on:click="navigateTo(cat.mid)" class="dropdown-item" :class="{ 'is-active' : active_el == cat.mid }">{{cat.name}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <div class="control" v-if="catalogTags">
                <div class="dropdown is-up" :class="{ 'is-active' : isFilterActive }">
                    <div class="dropdown-trigger">
                        <button class="button is-link is-medium" aria-haspopup="true" aria-controls="tag-filter" v-on:click="swapFilterActive">
                            <span class="icon is-small is-size-6" :class="{ 'has-text-info' : fltrParm.tag }">
                                <font-awesome-icon icon="filter"/>
                            </span>
                        </button>
                    </div>
                    <div class="dropdown-menu" id="tag-filter" role="menu">
                        <div class="dropdown-content padding-5">
                            <div class="tags are-small">
                              <span v-for="tag in catalogTags" :key="tag.mid" class="tag" :class="[fltrParm.tag === tag.mid? 'is-info': '']">
                                  <a :class="[fltrParm.tag === tag.mid? 'has-text-white': 'has-text-info']" v-on:click="menuFilterTap(tag)">{{tag.name}}</a>
                                  <button class="delete is-small" v-on:click="deleteFilterTag" v-if="fltrParm.tag === tag.mid"></button>
                              </span>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <div class="control content-flex">
                <a v-if="cartCount > 0" class="button is-success is-medium w-100" v-on:click="displayCart">
                  <span class="border-box count-box mr-5 is-size-6"> {{cartCount}} </span>
                  <span class="icon is-small is-size-6">
                      <font-awesome-icon icon="shopping-cart">
                      </font-awesome-icon>
                  </span>
                  <span class="is-pulled-right ml-5 is-size-6" v-html="formatPrice(totalCost)"></span>
                </a>
              </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import item from './Item'
import Util from '@/util'
import Constants from '@/util/constants'
// import CarouselSlider from '@/components/ux/CarouselSlider'

export default {
  name: 'catalog',
  components: {
    item
    // CarouselSlider
  },
  computed: {
    ...mapState('catalog', ['catalog', 'catalogCategories', 'catalogTags', 'filterCats']),
    ...mapState('business', ['resourceId']),
    ...mapState('cart', ['customerInfo']),
    ...mapGetters({
      cartCount: 'cart/getCartCount',
      totalCost: 'cart/totalSale',
      getEntity: 'catalog/getEntityById'
    }),
    filteredCatalog () {
      const filterParams = this.fltrParm
      const catalogArr = this.catalog
      let catCopy = {}
      const filterFn = item => {
        if (filterParams.searchText && item.name.toLowerCase().indexOf(filterParams.searchText.toLowerCase()) > -1) {
          return true
        }
        if (filterParams.tag && item.tagIds && item.tagIds.includes(filterParams.tag)) {
          return true
        }
        return false
      }
      const nestedFltrFn = (catalog, filterFn) => {
        const formCatObj = (cat) => {
          let catObj = {}
          let items = []

          if (cat.items) {
            items = Object.values(cat.items).filter(filterFn)
          }
          if (!Util.isEmpty(items)) {
            catObj = Util.cloneObj(cat)
            if (!Util.isEmpty(items)) {
              catObj.items = items
            }
          }

          return catObj
        }
        Object.values(catalog).forEach(cat => {
          let subCat = {}
          let catObj = Util.cloneObj(cat)

          if (!catCopy[cat.mid]) {
            catCopy[cat.mid] = {}
          }
          if (cat.subCategories) {
            Object.values(cat.subCategories).forEach(sub => {
              let subObj = formCatObj(sub)

              if (subObj && subObj.items) {
                subCat[sub.mid] = subObj
              }
            })

            if (!Util.isEmpty(subCat)) {
              catCopy[cat.mid].subCategories = subCat
            }
          }
          if (cat.items) {
            let items = Object.values(cat.items).filter(filterFn)

            if (items) {
              catCopy[cat.mid].items = items
            }
          }
          if (catCopy[cat.mid].items || catCopy[cat.mid].subCategories) {
            catObj.items = catCopy[cat.mid].items
            catObj.subCategories = catCopy[cat.mid].subCategories
            catCopy[cat.mid] = catObj
          }
        })
      }

      if (Util.isEmpty(filterParams)) {
        return catalogArr
      }

      nestedFltrFn(catalogArr, filterFn)
      return catCopy
    },
    currentDeals () {
      const RL = window.RL
      const discounts = this.$store.getters['catalog/getApplicableDeals']
      let currDealVo = []

      if (!discounts) {
        return null
      }
      currDealVo = RL.dealutil.getCurrentDeals({
        discounts: discounts,
        branchTimes: [Util.formatDate({ zoneId: this.$store.getters['business/timeZone'].zoneId })],
        branchId: this.$store.getters['business/branchId'],
        membershipId: this.customerInfo ? this.customerInfo.membershipId : null,
        channelDefId: this.$store.getters['business/channelDefId'],
        transactionEnd: this.$store.getters['business/transactionEnd']
      })

      return currDealVo.map((d) => {
        let disc = this.getEntity('discounts', d.discountId)
        disc.dealTag = this.dealTag(disc)
        return disc
      })
    }
  },
  watch: {
    "$route.meta"({ showModal }) {
      this.showModal = showModal;
    },
    filteredCatalog (catalog) {
      this.$store.dispatch('catalog/filterCats', catalog)
    }
  },
  mounted () {
    this.searchText = ''
  },
  methods: {
    addItem () {
      const itemId = this.item.mid

      this.$store.dispatch('cart/addItem', {
        itemId: itemId,
        cb: cartItem => {
          this.displayItemDialog(cartItem.itemNumber)
        }
      })
    },
    displayCartItemDialog (itemNumber) {
      if (!itemNumber) {
        return
      }
      this.$router.push({ name: 'OutletCartItem', params: { itemNumber: itemNumber } })
    },
    displayItemDialog (itemId) {
      if (!itemId) {
        return
      }
      this.$router.push({ name: 'OutletItem', params: { itemId: itemId } })
    },
    swapMenuActive () {
      this.isMenuActive = !this.isMenuActive
      this.isFilterActive = false
    },
    swapFilterActive () {
      this.isFilterActive = !this.isFilterActive
      this.isMenuActive = false
    },
    navigateTo (id) {
      const scrollToEl = document.getElementById('catalog_' + id)

      if (scrollToEl) {
        this.isMenuActive = false
        this.active_el = id
        scrollToEl.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        })
      }
    },
    formatPrice (number) {
      return Util.formatPrice(number)
    },
    displayCart () {
      this.$router.push({ name: 'OutletCart' })
    },
    isEmpty (obj) {
      return Util.isEmpty(obj)
    },
    filterBySearch () {
      if (this.searchText !== '') {
        this.fltrParm = {
          searchText: this.searchText
        }
        return
      }
      this.clearFilter()
    },
    filterByTag (tag) {
      if (this.fltrParm.tag === tag.mid) {
        this.deleteFilterTag()
        return
      }
      this.fltrParm = {
        tag: tag.mid
      }
    },
    deleteFilterTag () {
      this.clearFilter()
    },
    closeSearch () {
      this.displaySearch = false
      this.clearFilter()
    },
    clearFilter () {
      this.fltrParm = {}
    },
    menuFilterTap (tag) {
      this.filterByTag(tag)
      this.isFilterActive = false
    },
    displayDealDetail (dealId) {
      if (!dealId) {
        return
      }
      this.$router.push({ name: 'OutletDeal', params: { dealId: dealId } })
    },
    dealTag (deal) {
      let discHtml = ''
      const dealInfo = deal[deal.discountType]
      const formatPrice = (price) => {
        return `${Constants.currency[this.$store.getters['business/currency']]} ${price}`
      }
      const getAbsDiscTxt = (getInfo) => {
        let text = 'at'
        switch (getInfo.getType) {
          case 'Value':
            text += `<p>${formatPrice(getInfo.absoluteValue)} Off</p>`
            break;
          case 'Percentage':
            text += `<p>${getInfo.percentageDiscount}% Off</p>`
            break;
          case 'Loyalty':
            text += `<p>${getInfo.loyaltyPoints} poinits</p>`
            break;
        }
        return text
      }

      switch (deal.discountType) {
        case 'Absolute':
          discHtml = `<p>${formatPrice(deal.discountRate)} Off</p>`
          break;
        case 'Percentage':
          discHtml = `<p>${deal.discountRate}% Off</p>`
          break;
        case 'BuyX':
          discHtml += `<p>Buy ${dealInfo.buyInfo.buyQty} ${getAbsDiscTxt(dealInfo.getInfo)}</p>`
          break;
        case 'BuyXGetX':
        case 'BuyXGetY':
          discHtml += `<p>Buy ${dealInfo.buyInfo.buyQty}</p>`
          discHtml += `<p>Get ${dealInfo.getInfo.getQty}</p>`
          break;
        default:
          break;
      }
      return discHtml
    },
    displayCatalogErr (err) {
      Util.notify(this, err);
    }
  },
  data () {
    return {
      itemId: null,
      active_el: null,
      isMenuActive: false,
      isFilterActive: false,
      showModal: this.$route.meta.showModal,
      displaySearch: false,
      fltrParm: {},
      tag: null,
      searchText: ''
    }
  }
}
</script>
<style lang="scss" scoped>
  .count-box{
    padding-right: 0.25em;
    padding-left: 0.25em;
  }
  .top-pos-0{
    top: 0rem;
  }
</style>
